"use client";
import { cn as e } from "../../../utils/utils.mjs";
import { getAccessibleFocusStyles as t } from "../../../utils/styles.mjs";
import { forwardRef as n, useEffect as r, useRef as i, useState as a } from "react";
import { jsx as o } from "react/jsx-runtime";
import { cva as s } from "class-variance-authority";
//#region src/components/atoms/Input/Input.tsx
var c = s("\n    block\n    w-full\n    rounded-md\n    transition-colors\n    placeholder:transition-colors\n    disabled:cursor-not-allowed\n    disabled:opacity-60\n    ", {
	variants: {
		tone: {
			dark: "bg-gray-925 text-white placeholder:text-gray-400 border-gray-700",
			light: "bg-white text-gray-900 placeholder:text-gray-500 border-gray-300"
		},
		size: {
			sm: "text-sm leading-5 px-3 py-2 h-10",
			md: "text-base leading-6 px-4 py-3 h-12",
			lg: "text-base leading-6 px-4 py-4 h-14"
		}
	},
	defaultVariants: {
		tone: "light",
		size: "md"
	}
}), l = n(({ className: n, size: s = "md", tone: l = "light", keyboardFocusOnly: u = !1, ...d }, f) => {
	let [p, m] = a(!1), h = i("mouse");
	r(() => {
		if (!u) return;
		let e = () => {
			h.current = "mouse";
		}, t = (e) => {
			e.key === "Tab" && (h.current = "keyboard");
		};
		return document.addEventListener("mousedown", e), document.addEventListener("keydown", t), () => {
			document.removeEventListener("mousedown", e), document.removeEventListener("keydown", t);
		};
	}, [u]);
	let g = () => {
		u && h.current === "keyboard" && m(!0);
	}, _ = () => {
		u && m(!1);
	}, v = u ? e("focus:outline-none focus:ring-0 focus:border-none", "focus-visible:outline-none focus-visible:ring-0 focus-visible:border-none", p && "!outline-solid !outline-2 !outline-offset-2 !outline-white !ring-2 !ring-blue-600") : t();
	return /* @__PURE__ */ o("input", {
		ref: f,
		className: e(c({
			size: s,
			tone: l
		}), v, n),
		onFocus: g,
		onBlur: _,
		...d
	});
});
l.displayName = "Input";
//#endregion
export { l as Input };
